module.exports = __webpack_public_path__ + "img/room.fed71b77.svg";